// ハンガーラック: フレーム構造、横棒あり
import { Box } from '@react-three/drei'

export default function HangerRackMesh({ width, height, depth, position, color, isSelected }) {
    const poleThickness = width * 0.04
    const barY = position[1] + height / 2 - height * 0.15

    return (
        <group>
            {/* 左側支柱 */}
            <Box args={[poleThickness, height, poleThickness]} position={[-width / 2 + poleThickness / 2, position[1], 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 右側支柱 */}
            <Box args={[poleThickness, height, poleThickness]} position={[width / 2 - poleThickness / 2, position[1], 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ハンガーバー（横棒） */}
            <Box args={[width - poleThickness * 2, poleThickness, poleThickness]} position={[0, barY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 下部の棚板 */}
            <Box args={[width, height * 0.03, depth]} position={[0, position[1] - height / 2 + height * 0.015, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 左側支柱 */}
            <Box args={[poleThickness, height, poleThickness]} position={[-width / 2 + poleThickness / 2, position[1], 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 右側支柱 */}
            <Box args={[poleThickness, height, poleThickness]} position={[width / 2 - poleThickness / 2, position[1], 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - ハンガーバー */}
            <Box args={[width - poleThickness * 2, poleThickness, poleThickness]} position={[0, barY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 下部の棚板 */}
            <Box args={[width, height * 0.03, depth]} position={[0, position[1] - height / 2 + height * 0.015, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
